import { TinyEmitter } from "tiny-emitter";
const emitter = new TinyEmitter();
const tinyEventBus = () => {
  return { emitter };
};
export default tinyEventBus;
